import { showGuestModal } from "store/guestModal/actions";
import { store } from "../store/rootReducer";

export const showLoginModal = () => {
  store.dispatch(showGuestModal());
};
